import transferIndexOptions from './transferIndexOptions.json';
import { CommonAssetDto, TransferIndexFieldGroup } from './types';

export const getAssetTransferIndex = (asset: CommonAssetDto, round?: boolean): number => {
  try {
    const value = calculateTransferIndex(asset);
    return round ? Math.round(value) : value;
  } catch (er) {
    return 0;
  }
};

const groupsWeight = {
  [TransferIndexFieldGroup.CRUCIAL]: 70,
  [TransferIndexFieldGroup.ESSENTIAL]: 20,
  [TransferIndexFieldGroup.NECESSARY]: 5,
  [TransferIndexFieldGroup.OTHER]: 5,
};

const calculateTransferIndex = (asset: CommonAssetDto): number => {
  const options = transferIndexOptions.indexes.find((item) => item.type === asset.category);

  if (!options) {
    return 0;
  }

  const groupsFieldsInfo: Record<TransferIndexFieldGroup, { filled: number; total: number }> = {
    [TransferIndexFieldGroup.CRUCIAL]: { filled: 0, total: 0 },
    [TransferIndexFieldGroup.ESSENTIAL]: { filled: 0, total: 0 },
    [TransferIndexFieldGroup.NECESSARY]: { filled: 0, total: 0 },
    [TransferIndexFieldGroup.OTHER]: { filled: 0, total: 0 },
  };

  // Get filling fields info
  const fieldsWeights = Object.entries(options.map) as [string, TransferIndexFieldGroup][];
  const groupsWeights = fieldsWeights.reduce((acc, [fieldName, fieldGroup]) => {
    const group = acc[fieldGroup];

    group.total += 1;
    if (isNotEmptyValue(asset[fieldName])) {
      group.filled = 1;
    }

    return acc;
  }, groupsFieldsInfo);

  const transferIndex = Object.entries(groupsWeights).reduce((acc, [group, info]) => {
    // @ts-ignore
    const groupWeight = groupsWeight[group];

    return acc + (groupWeight * info.filled) / info.total;
  }, 0);

  return transferIndex;
};

const isNotEmptyValue = (value: boolean | number | string | object | null | undefined) => {
  if (value === null || value === undefined) {
    return 0;
  }

  if (typeof value === 'boolean') {
    return 1;
  }

  if (typeof value === 'number') {
    return 1;
  }

  if (typeof value === 'string') {
    return value === '' ? 0 : 1;
  }

  if (typeof value === 'object') {
    if (value instanceof Array) {
      return value.length === 0 ? 0 : 1;
    } else {
      return 1;
    }
  }

  return 0;
};
